import { createStyles, Radio, UnstyledButton } from '@mantine/core';
import { replaceAmpersandWithAnd } from '@repo/common/utils/stringUtils';
import { Text } from '@repo/foundations';
import { capitalize } from 'lodash-es';

interface ConnectionTypeRadioProps {
	group: string;
	active: boolean;
	selectGroup: (group: string) => void;
	disabled?: boolean;
}

const useStyles = createStyles((theme, { active }: { active: boolean }) => ({
	wrapper: {
		display: 'flex',
		alignItems: 'center',
		borderWidth: 1,
		borderStyle: 'solid',
		borderColor: theme.other.getColor('border/primary/default'),
		borderRadius: theme.radius.sm,
		padding: theme.spacing.sm,
		gap: theme.spacing.xs,
		backgroundColor: theme.other.getColor('surface/primary/default'),
		'&:hover': {
			backgroundColor: theme.other.getColor('surface/primary/hover'),
		},
		'&[data-active=true]': {
			backgroundColor: theme.other.getColor('surface/primary/active'),
		},
	},
}));

function ConnectionTypeRadio({
	group,
	active,
	selectGroup,
	disabled = false,
}: ConnectionTypeRadioProps) {
	const { classes, theme } = useStyles({ active });

	return (
		<UnstyledButton
			className={classes.wrapper}
			onClick={() => selectGroup(group)}
			data-active={active}
			disabled={disabled}
		>
			<Radio value={group} />
			<Text size="sm" weight="semibold" lh={`${theme.other.space[6]}px`}>
				{replaceAmpersandWithAnd(capitalize(group))
					.replace('Active directory', 'Azure AD')
					.replace('Windows authentication', 'Windows AD')}
			</Text>
		</UnstyledButton>
	);
}

export default ConnectionTypeRadio;
